<template>
    <div class="invite_main">
        <div class="invite_header">
            <div class="icon">
                <div class="eng">广州劳动仲裁院</div>
                <div>GUANGZHOU LABOR ARBITRATION COURT</div>
            </div>
            <div class="title">广州劳动人事微仲裁</div>
        </div>
        <div class="invite_content">
            <div class="invite-login">
                <div class="login-title">
                    <div class="title">视频入口</div>
                    <div class="bottom-line">Video entry</div>
                </div>
                <el-form :model="invite" :rules="inviterules" autocomplete="off" @submit.native.prevent ref="invite" class="demo-ruleForm">
                    <el-form-item prop="mobilePhone">
                        <el-input class="invite_input" maxlength="11" v-model="invite.mobilePhone" autocomplete="new-password" @keyup.enter="submitForm('invite')" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input class="invite_input" type="password" v-model="invite.password" autocomplete="new-password" @keyup.enter="submitForm('invite')" placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                </el-form>
								<div class="right" @click="forgetPwd">忘记密码?</div>
                <div class="enter" @click="submitForm('invite')">登录</div>
            </div>
        </div>
    </div>
</template>
<script>
import { inviteEnterWatch } from "@/api/meeting";
import { userLoginByMobile, checkIsFirstLogin } from "@/api/login.js";
import {
  setStore,
  getStore,
  removeStore,
  setStoreSession,
  getStoreSession
} from "@/utils/utils.js";
export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      var myreg = /^1[3-9]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!myreg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    return {
      invite: {
        mobilePhone: "",
        password: "",
        loginType: "WORK_USER_LOGIN_TYPE"
      },
      inviterules: {
        mobilePhone: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  watch: {},
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            mobilePhone: this.invite.mobilePhone
          };
          localStorage.setItem(
            "oldPassword",
            this.$Base64.encode(this.invite.password)
          );
          userLoginByMobile(this.invite).then(
            res => {
              if (res.data.code === 1000) {
                let data = res.data.data;
                removeStore("loginInfo_worker");
                removeStore("loginInfouser");
                removeStore("loginInfoEnterprise");
                setStore("flk", data.authToken);
                setStore("refreshToken", data.refreshToken);
                setStoreSession("haslogin", "yes");
                setStore("loginInfo_worker", data.loginInfo);
                setStore("isOutter", 0);
                removeStore("appName");
                let userRoles = data.loginInfo.userRoles;
                let staffRole = userRoles.filter(item => {
                  return (
                    item.roleCode == "MEDIATOR" || item.roleCode == "CLERK"
                  );
                });
                checkIsFirstLogin(params).then(
                  res => {
                    if (res.data.code === 1000) {
                      if (res.data.data === "1") {
                        this.$router.push({ path: "/resetPassword" });
                      } else if (
                        res.data.data === "0" &&
                        staffRole &&
                        staffRole.length
                      ) {
                        this.$router.push({ path: "/caseInHand" });
                      } else {
                        this.$router.push({ path: "/personManage" });
                      }
                    } else {
                      this.$message({
                        type: "error",
                        message: res.data.message
                      });
                    }
                  },
                  err => {
                    this.$message.error(err);
                  }
                );
              } else {
                this.$message.error(res.data.message);
                this.reserror = res.data.message;
                this.showreserror = true;
                setTimeout(() => {
                  this.showreserror = false;
                }, 2000);
              }
            },
            err => {
              this.$message.error(err);
            }
          );
        } else {
          return false;
        }
      });
    },
    forgetPwd() {
      this.$router.push({ path: "/forgetPassword" });
    },
    goLogin() {
      this.$router.push({ path: "/login" });
    }
  },
  components: {}
};
</script>
<style lang="scss">
.invite_main {
  height: 100%;
  width: 100%;
  background: url("../../assets/bg.png") no-repeat center top;
  background-size: 100% 100%;
  .invite_header {
    display: flex;
    align-items: center;
    height: 110px;
    width: 85.5%;
    margin: 0 auto;
    color: #fff;
    .icon {
      position: relative;
      margin-right: 40px;
      .eng {
        font-size: 14px;
        letter-spacing: 25px;
      }
    }
    .icon:before {
      content: "";
      position: absolute;
      display: block;
      right: -10px;
      top: 10px;
      width: 1px;
      height: 0;
      border-top: 20px solid #ffffff;
    }
    .title {
      font-size: 28px;
      letter-spacing: 12px;
    }
  }
  .invite_content {
    position: relative;
    height: 80%;
    width: 85.5%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../assets/bg_content.png") no-repeat center top;
    background-size: 100% 100%;
    .invite-login {
      position: absolute;
      right: 83px;
      height: 500px;
      padding: 0 50px;
      background-color: #fff;
      border-radius: 4px;
      .login-title {
        text-align: center;
        margin-bottom: 50px;
        .title {
          padding-top: 60px;
          font-size: 26px;
          letter-spacing: 5px;
        }
        .bottom-line {
          font-size: 14px;
          font-family: "PingFang-SC-Light";
          letter-spacing: 4px;
        }
      }
      .right {
        position: absolute;
        right: 45px;
        font-size: 15px;
        cursor: pointer;
      }
      .enter {
        margin: 70px auto;
        width: 300px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        background-image: linear-gradient(90deg, #0083c8 0%, #142f9e 100%),
          linear-gradient(#0d44b0, #0d44b0);
        background-blend-mode: normal, normal;
        box-shadow: 0px 8px 18px 0px rgba(0, 59, 185, 0.3);
        background-blend-mode: normal, normal;
        border-radius: 24px;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
      }
      .el-form-item {
        margin-bottom: 30px;
        .el-input__inner {
          border: 0;
          padding: 0;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
        }
      }
    }
  }
}
</style>

